import script from "./SportHeroBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportHeroBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SportHeroBanner.vue?vue&type=style&index=0&id=5b2fb028&lang=scss"

const __exports__ = script;

export default __exports__